import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { AddCustomMachineTypeRequest } from '../types/machine-setup-types';

export class AddCustomMachineTypeUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(data: AddCustomMachineTypeRequest): Promise<{ isSuccess: boolean; errorMessage?: string }> {
    return this.repository.addCustomMachineType(data);
  }
}
